// import GUI from 'lil-gui'
import { gsap, Power3 } from 'gsap';
import * as THREE from 'three'
// import { Camera } from 'three'
import Experience from '../Experience'

export default class Sneaker {

    constructor() {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.debug = this.experience.debug

        this.resource = this.resources.items.sneakerModel

        this.redTexture = this.resources.items.bakeTextureRed
        this.blueTexture = this.resources.items.bakeTextureBlue
        this.yellowTexture = this.resources.items.bakeTextureYellow
        this.greenTexture = this.resources.items.bakeTextureGreen
        this.purpleTexture = this.resources.items.bakeTexturePurple

        console.log(this.resources);

        this.setTexture(this.redTexture)
        this.setMaterial()
        this.setModel()

        if (this.debug.active) {

            this.debugFolder = this.debug.ui.addFolder('Sneakers')

            this.setGui()
        }

        this.accordionTitle = document.querySelector('a.uk-accordion-title')
        this.accordionTitle.addEventListener('click', () => this.resetAllSelectedColors())
        this.allAccordionTitle = document.querySelectorAll('a.uk-accordion-title')
        for (const title of this.allAccordionTitle) {

            title.addEventListener('click', () => this.setAccordionHeight())
        }

        this.tomaiaSelect = document.querySelector('#select-tomaia ul')
        this.tomaiaSelect.addEventListener('click', (evt) => this.selectTexture(evt, 'tomaia'))

        this.goatSlider = document.querySelector('#yatay-b-goat ul')
        this.goatSlider.addEventListener('click', (evt) => this.selectColor(evt, 'yatay-b-goat'))

    }

    selectTexture(event, object) {

        console.log(event);

        let clickedLi = event.target.closest("li")

        console.log(clickedLi);

        if (clickedLi) {

            let selectedTexture
            let target = clickedLi
            let texturesList = document.querySelectorAll('#select-' + object + ' ul li')
            for (const tList of texturesList) {
                tList.classList.remove("selected-texture")
            }
            target.classList.add("selected-texture")
            let meta = target.querySelector('.el-meta').innerHTML.replace(/\s/g, "")
            let title = target.querySelector('.el-title').innerHTML
            document.querySelector('h1.el-title').innerHTML = title
            let content = target.querySelector('.el-content').innerHTML
            document.getElementById('specs-' + object).innerHTML = content
            console.log(meta);
            // console.log(content);
            switch (true) {
                case (meta == 'yatay-b-goat'):
                    selectedTexture = this.redTexture
                    break;
                case (meta == 'yatay-b-drip'):
                    selectedTexture = this.blueTexture
                    break;
                case (meta == 'yatay-b-glow-up'):
                    selectedTexture = this.yellowTexture
                    break;
                case (meta == 'yatay-b-salty'):
                    selectedTexture = this.greenTexture
                    break;
                default:
                    selectedTexture = this.redTexture
                    break;
            }
            this.scene.remove(this.model)
            this.setTexture(selectedTexture)
            this.setMaterial()
            this.setModel()

            document.getElementById('yatay-b-goat').style.visibility = 'hidden'
            document.getElementById('yatay-b-drip').style.visibility = 'hidden'
            document.getElementById('yatay-b-glow-up').style.visibility = 'hidden'
            document.getElementById('yatay-b-salty').style.visibility = 'hidden'
            document.getElementById('yatay-b-goat').style.display = 'none'
            document.getElementById('yatay-b-drip').style.display = 'none'
            document.getElementById('yatay-b-glow-up').style.display = 'none'
            document.getElementById('yatay-b-salty').style.display = 'none'
            let colorsPalette = document.getElementById(meta)
            colorsPalette.style.visibility = 'visible'
            colorsPalette.style.display = 'block'
        }
    }

    // selectFodera(event) {

    //     console.log(event);

    //     if (event.target.classList.contains('el-item')) {

    //         let selectedTexture
    //         let target = event.target
    //         let meta = target.querySelector('.el-meta').innerHTML
    //         let content = target.querySelector('.el-content').innerHTML
    //         document.getElementById('specs-fodera').innerHTML = content
    //         console.log(meta);
    //         console.log(content);
    //         switch (true) {
    //             case (meta == 'red'):
    //                 selectedTexture = this.redTexture
    //                 break;
    //             case (meta == 'blue'):
    //                 selectedTexture = this.blueTexture
    //                 break;
    //             default:
    //                 selectedTexture = this.redTexture
    //                 break;
    //         }
    //         this.scene.remove(this.model)
    //         this.setTexture(selectedTexture)
    //         this.setMaterial()
    //         this.setModel()
    //     }


    // }

    selectColor(event, object) {

        console.log('COLOR', event);

        let clickedLi = event.target.closest("li")
        let selectedTexture
        let target = clickedLi
        let colorsList = document.querySelectorAll('#' + object + ' ul li')
        for (const tList of colorsList) {
            tList.classList.remove("selected-texture")
        }
        target.classList.add("selected-texture")
        let meta = target.querySelector('.el-meta').innerHTML.replace(/\s/g, "")
        meta = object + '-' + meta

        switch (true) {
            case (meta == 'yatay-b-goat-snowy'):
                selectedTexture = this.redTexture
                break;
            case (meta == 'yatay-b-goat-pitch-dark'):
                selectedTexture = this.blueTexture
                break;
            case (meta == 'yatay-b-goat-mandarin'):
                selectedTexture = this.yellowTexture
                break;
            case (meta == 'yatay-b-goat-lavander'):
                selectedTexture = this.greenTexture
                break;
            default:
                selectedTexture = this.redTexture
                break;
        }

        console.log(meta);
        console.log(selectedTexture);

        this.scene.remove(this.model)
        this.setTexture(selectedTexture)
        this.setMaterial()
        this.setModel()

    }

    resetAllSelectedColors() {
        const goatColors = document.querySelectorAll('#yatay-b-goat ul li')
        const dripColors = document.querySelectorAll('#yatay-b-drip ul li')
        const glowColors = document.querySelectorAll('#yatay-b-glow-up ul li')
        const saltyColors = document.querySelectorAll('#yatay-b-salty ul li')

        const colorsArray = [goatColors, dripColors, glowColors, saltyColors]

        for (const colors of colorsArray) {

            for (const color of colors) {
                color.classList.remove('selected-texture')
            }

            colors[0].classList.add('selected-texture')

        }

    }

    setAccordionHeight() {
        let productsAccordion = document.querySelector('#products-accordion')
        let canvasInterface = document.querySelector('#canvas-interface')
        console.log(productsAccordion);
        let accordionHeight = productsAccordion.offsetHeight
        gsap.to(canvasInterface, {
            duration: 0.5,
            height: (accordionHeight + 70) + 'px',
            ease: Power3.easeOut
        })

    }

    updateAllMaterials() {

        this.model.traverse((child) => {

            if (child.type === 'Mesh') {

                child.material = this.material
            } else if (child.type === 'Group') {

                for (const children of child.children) {

                    if (children.type === 'Mesh') {
                        children.material = this.material
                    }
                }
            }
        })
    }

    setModel() {

        this.model = this.resource.scene
        this.model.scale.set(0.1, 0.1, 0.1)
        this.updateAllMaterials()

        const modelBox = new THREE.Box3().setFromObject(this.model)

        const centerX = (modelBox.max.x - modelBox.min.x) / 4
        const centerY = (modelBox.max.y - modelBox.min.y) / 4
        const centerZ = (modelBox.max.z - modelBox.min.z) / 4

        this.model.position.x = 0
        this.model.position.y = 0
        this.model.position.z = 0
        this.model.rotation.y = 0

        this.model.position.x = centerX
        this.model.position.y = -centerY * 1.5
        this.model.position.z = centerZ / 2
        // this.model.rotation.y = -(90 * Math.PI / 180)

        this.scene.add(this.model)

    }

    setTexture(texture) {
        this.texture = texture
        this.texture.flipY = false
        this.texture.flipX = false
        this.texture.encoding = THREE.sRGBEncoding

    }

    setMaterial() {
        this.material = new THREE.MeshBasicMaterial({ map: this.texture })
    }

    setGui() {
        this.debugFolder.add(this.model.position, 'x').name('position X').min(0).max(6).step(0.5)
        this.debugFolder.add(this.model.position, 'y').name('position Y').min(0).max(6).step(0.5)
        this.debugFolder.add(this.model.position, 'z').name('position Z').min(0).max(6).step(0.5)
    }

}